module.exports = __webpack_public_path__ + "img/10yilpremium.0b4ff59d.svg";